/**
 * The embedded ChatGPT review prompt.
 *
 * **This is the only copy in the codebase** (D-042). It is transcribed verbatim
 * from the canonical document, docs/export-format.md, which itself supersedes
 * the earlier variant in handoff §17. If the wording needs to change, change it
 * there first and copy it here — not the other way round.
 *
 * A test asserts the distinctive clauses are present, so a careless edit that
 * drops the "critique rather than accept" framing or the closing decision list
 * fails the build. That framing is the whole point of the two-opinion model
 * (D-008): the app makes its own call first, and asks to be argued with.
 */
export const REVIEW_PROMPT = `Review this weekly body-composition report as my phase-aware physique coach.

First identify my current phase, its objective, and its priority order. Interpret all data according to that phase. Do not apply fat-loss logic to maintenance or lean-bulk phases.

My long-term goal is to become lean, athletic, visibly defined, and muscular without becoming excessively bulky. Favor sustainable changes over aggressive ones. Preserve muscle, strength, recovery, and routine consistency. Because I have ADHD and respond well to routine, avoid recommending unnecessary changes that disrupt a working system.

This report includes the app's own rule-based recommendation. Treat it as the first coaching opinion. Critique it rather than automatically accepting it.

Tell me:

1. Whether you agree with the app's recommendation.
2. Whether I should stay the course or adjust.
3. What evidence supports your conclusion.
4. Whether my rate of weight change is appropriate for my current phase.
5. Whether waist, body-fat estimate, photos, and strength are moving consistently.
6. Whether there are signs of muscle loss, poor recovery, excessive fatigue, or unreliable data.
7. Whether the result may be explained by water retention, food volume, sodium, sleep, stress, travel, illness, or recent training.
8. The single highest-impact action for the coming week.
9. Up to two secondary actions only if they are clearly useful.

Do not overreact to a single weigh-in, one unusual measurement, or one poor workout. Use multi-week trends whenever available. Do not recommend reducing calories when adherence was too low to judge the current plan. Do not recommend multiple simultaneous adjustments unless there is a clear health or recovery reason.

Clearly separate observed facts, likely explanations, uncertainty, and recommendation.

End with one concise coaching decision: Stay the course; Improve adherence first; Gather more data; Make one small adjustment; Ease the current phase; or End or transition the phase.`
